import { DOMAIN_PREFIX } from '../../../constants/staticPageConstants';
import { render404Page } from '../../../utils/UtilFunctions';
import { sanitizeInput } from '../../Utils/CommonUtils';
import cmsPagesService from '../../cms/services/cms-pages.service';
import {
  DEFAULT_PAGE,
  DOMAIN_CODE,
  DOMAIN_HOST_URL_PREFIX,
} from '../constants';
import { IAUTHOR, IParams } from '../types';
import { getActiveAuthors } from './authorListUtils';

export const getAuthorSEODetails = (
  authorName: string,
  authorSlug: string,
  designation: string,
  description: string
) => {
  const domainData = DOMAIN_PREFIX[DOMAIN_CODE];
  const title = `${authorName}, ${designation} at ${domainData?.name}`;
  const metaDesc = description || '';
  const url = `${DOMAIN_HOST_URL_PREFIX}/authors/${authorSlug}`;

  return {
    title: title,
    metaDesc: metaDesc,
    url: url,
  };
};

export const getStaticPropsAuthorPostData = async ({ params }: IParams) => {
  const author = typeof params?.author === 'string' ? params.author : '';
  try {
    const res = await cmsPagesService.getAuthorPostsBySlug(
      sanitizeInput(author),
      DOMAIN_CODE,
      DEFAULT_PAGE
    );
    const data = await res.data;

    return {
      props: {
        authorName: data.author_details.name,
        data: data,
      },
    };
  } catch (err) {
    console.log('Error fetching author posts by slug');
    return render404Page();
  }
};

export const getStaticPathsData = async () => {
  const data = await getActiveAuthors(DOMAIN_CODE, DEFAULT_PAGE);
  const pathsArray = data.results.map((author: IAUTHOR) => {
    return {
      params: {
        author: author.slug,
      },
    };
  });
  return {
    paths: pathsArray,
    fallback: false,
  };
};
